import { CreateListModalComponent } from './../create-list-modal/create-list-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ListsService } from './../../../services/lists.service';
import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FavouritesData, ListsData } from '@models/lists.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { isPlatformBrowser, SlicePipe, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-add-product-lists',
  templateUrl: './add-product-lists.component.html',
  styleUrls: ['./add-product-lists.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, MatIconModule, MatDialogModule, MatProgressSpinnerModule, MatCheckboxModule, MatButtonModule, SlicePipe, TitleCasePipe, TranslateModule]
})
export class AddProductListsComponent implements OnInit {

  public loading = false;
  public product: any;
  public addProductToFavourites = false;
  public listLoading = true;
  public listsForAddProducts: any[] = [];
  public favouritesList: FavouritesData;
  public myLists: any[] = [];
  public favouritesCountItems = 0;

  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  private plaformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.plaformId);

  constructor(
    private listsService: ListsService,
    private dialogRef: MatDialogRef<AddProductListsComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  ngOnInit(): void {
    this.product = this.data;
    this.getLists();
  }

  public selectList(id: number, index: number): void {
    const exitsList = this.listsForAddProducts.findIndex(item => item === id);
    if (exitsList !== -1) {
      this.listsForAddProducts.splice(exitsList, 1);
      this.myLists[index].selected = false;
    } else {
      this.listsForAddProducts.push(id);
      this.myLists[index].selected = true;
    }
  }

  public async getLists(): Promise<void> {
    await this.getFavourites();
    await this.getMyLists();
  }

  public async getFavourites(): Promise<void> {
    if (this.isBrowser) {
      const token = JSON.parse(localStorage.getItem('token') || '{}');
      if (token?.jwt) {
        try {
          const { data } = await this.listsService.getFavouritesLists();
          this.favouritesList = data;
          this.favouritesCountItems = this.favouritesList.items.length;
        } catch (error) { }
      }
    }
  }

  public async getMyLists(): Promise<void> {
    if (this.isBrowser) {
      const token = JSON.parse(localStorage.getItem('token') || '{}');
      if (token?.jwt) {
        try {
          const { data } = await this.listsService.getMyLists();
          this.myLists = data.map((list: ListsData) => ({
            ...list,
            count: list.total_items,
            selected: false
          }));
          this.listLoading = false;
        } catch (error) {
          this.listLoading = false;
        }
      }
    }
  }

  public addToAddList(): void {
    this.addProductToFavourites = !this.addProductToFavourites;
  }

  public async addProductToList(): Promise<void> {
    this.loading = true;
    try {
      const data = {
        items: [
          {
            sku: this.product.id,
            quantity: this.product.quantity,
            format: this.product.unit
          }
        ]
      };
      if (this.addProductToFavourites) {
        await this.listsService.addProductToFavouritesList(data);
      }
      if (this.listsForAddProducts.length > 0) {
        this.listsForAddProducts.forEach(async (id: number) => {
          await this.listsService.addProductToMyList(data, id);
        });
      }
      this.loading = false;
      this.closeModal(true);
    } catch (error) {
    }
  }

  public openCreateListModal(): void {
    this.closeModal(false);
    this.dialog.open(CreateListModalComponent, {
      width: '738px',
      disableClose: true,
      autoFocus: false
    });
  }

  public closeModal(status: boolean): void {
    this.dialogRef.close(status);
  }

}
